import { cn } from '../lib/utils';

/** Public SVG assets under apps web/admin public (see docs/branding/BRAND.md). */
export type BrandLogoVariant =
  | 'full'
  | 'mark'
  | 'wordmark'
  | 'on-dark'
  | 'on-dark-mark'
  | 'on-dark-wordmark'
  | 'mono'
  | 'favicon';

const SRC: Record<BrandLogoVariant, string> = {
  full: '/logo.svg',
  mark: '/logo-mark.svg',
  wordmark: '/logo-wordmark.svg',
  'on-dark': '/logo-on-dark.svg',
  'on-dark-mark': '/logo-on-dark-mark.svg',
  'on-dark-wordmark': '/logo-on-dark-wordmark.svg',
  mono: '/logo-mono.svg',
  favicon: '/favicon.svg',
};

function isMarkVariant(variant: BrandLogoVariant): boolean {
  switch (variant) {
    case 'mark':
    case 'on-dark-mark':
    case 'favicon':
      return true;
    case 'full':
    case 'wordmark':
    case 'on-dark':
    case 'on-dark-wordmark':
    case 'mono':
      return false;
    default: {
      const _exhaustive: never = variant;
      return _exhaustive;
    }
  }
}

export interface BrandLogoProps {
  variant?: BrandLogoVariant;
  /** Intrinsic height in px (width follows viewBox). Default 32. */
  size?: number;
  alt?: string;
  className?: string;
}

/**
 * ExamFlow brand mark / wordmark from static public SVGs.
 * Prefer this over letter badges (`E` / `EF`) in shell chrome.
 */
export function BrandLogo({
  variant = 'full',
  size = 32,
  alt = 'ExamFlow',
  className,
}: BrandLogoProps) {
  const mark = isMarkVariant(variant);
  // logo.svg viewBox 457.63×80 → ~5.72 aspect
  const width = mark ? size : Math.round(size * (457.63 / 80));

  return (
    <img
      src={SRC[variant]}
      alt={alt}
      width={width}
      height={size}
      decoding="async"
      className={cn(mark ? 'shrink-0' : 'w-auto shrink-0', className)}
      style={{ height: size, width: mark ? size : 'auto' }}
    />
  );
}
